import { SVGProps } from '@components/Icon/types';

export const Overtime = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.8, 2.55)">
      <path
        d="M9.47461 0C14.0157 5.42842e-05 17.9037 3.21998 18.7705 7.6543L18.8721 7.50293C19.0963 7.17101 19.5476 7.08276 19.8799 7.30664C20.212 7.5309 20.2993 7.98116 20.0752 8.31348L18.8262 10.1885L18.7783 10.2529C18.6583 10.3974 18.4857 10.4917 18.2969 10.5117H18.2236L18.082 10.4971C17.943 10.4688 17.8143 10.3991 17.7129 10.2969L16.1504 8.73535C15.8678 8.45232 15.8677 7.99294 16.1504 7.70996C16.4334 7.42716 16.8927 7.42734 17.1758 7.70996L17.334 7.86914C16.4796 3.67007 12.4537 0.86033 8.18652 1.55371C3.81277 2.26468 0.842352 6.38661 1.55273 10.7607C2.18386 14.645 5.53948 17.4984 9.47461 17.498H9.47656C11.9565 17.543 14.3015 16.3733 15.7578 14.3652C15.99 14.0395 16.4433 13.9634 16.7695 14.1953C17.0955 14.4275 17.1715 14.8808 16.9395 15.207C15.2118 17.5993 12.4239 18.9954 9.47363 18.9473C4.2416 18.9465 0 14.7058 0 9.47363C0.000341518 4.24143 4.24239 0.00025721 9.47461 0Z"
        fill={fill}
      />
      <path
        d="M9.41211 3.38672C9.8402 3.38674 10.1875 3.73402 10.1875 4.16211V9.39941L13.5996 11.9824C13.942 12.2393 14.0107 12.7249 13.7539 13.0674C13.497 13.4095 13.0113 13.4784 12.6689 13.2217L8.91895 10.4102L8.91504 10.4062C8.74081 10.2656 8.63685 10.0337 8.63672 9.78711V4.16211C8.63675 3.73425 8.98433 3.3871 9.41211 3.38672Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'overtime';
